export interface CmsDirectDebitBankInstruction {
  directDebitBankInstructionBody: string;
  directDebitBankInstructionTitle: string;
}
